import React from "react";

export const ArrowLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="206"
    height="343"
    viewBox="0 0 206 343"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M201.737 4.73851C117.369 31.7354 28.3847 88.5888 7.38196 180.886C-7.83948 247.778 50.3648 286.784 106.678 300.842C121.452 304.53 166.546 312.054 151.607 309.102C143.679 307.535 140.219 300.475 135.476 294.271C128.204 284.759 104.219 258.119 113.034 266.223C126.627 278.719 135.779 294.207 148.167 307.737C149.642 309.348 154.57 312.586 155.383 314.737C155.604 315.322 154.239 315.258 153.633 315.409C149.883 316.345 146.289 317.549 142.674 318.927C129.374 323.998 117.709 330.989 105.606 338.278"
      stroke="#EEDAFF"
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);
